import { GET_SOCIALMEDIA } from "../const";
import { SocialMediaType } from "../type/socialMedia.type";

export const getSocialMedias = (data: SocialMediaType) => {
    return {
        type: GET_SOCIALMEDIA,
        payload: data,
    };
};
